import { action, computed, observable, reaction, makeObservable } from 'mobx';
import React from 'react';
import {SuccessResponse, uploadedFiles} from '../../../../../domain';
import {Disposers, HttpPromiseState, toastrHelper, toInt} from '../../../../../lib/helpers';
import {SyncedVideoModel} from '../models';

export class SyncedVideoEditStore {
  @observable
  videoUrl: string | null;
  @observable.ref
  videoFile: File | null;
  @observable.ref
  videoUpload: HttpPromiseState<SuccessResponse> | null;

  private readonly disposers = new Disposers();

  constructor() {
    makeObservable(this);
    this.videoUrl = null;
    this.videoFile = null;
    this.videoUpload = null;
    this.setup();
  }

  @action
  handleImageFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files === null || files.length === 0)
      this.videoFile = null;
    else
      this.videoFile = files[0];
  };

  @action
  uploadImage = () => {
    if (this.videoFile === null)
      return;
    if (this.videoUpload?.isPending === true)
      return;
    this.videoUpload = uploadedFiles.uploadVideo(this.videoFile);
  };

  @action
  clearVideo = () => {
    this.videoUrl = null;
  };

  @action
  sync = (model: SyncedVideoModel) => {
    this.videoUrl = model.videoUrl;
    this.videoFile = null;
    this.videoUpload = null;
  };

  @computed
  get valid(): boolean {
    return this.videoUrl !== null;
  }

  @computed
  get x9Contents(): string {
    if (this.videoUrl === null)
      return '';
    const model: SyncedVideoModel = {
      videoUrl: this.videoUrl
    };
    return JSON.stringify(model);
  }

  private setup() {
    this.disposers.add(reaction(
      () => this.videoUpload?.state,
      this.afterVideoUploaded));
  }

  @action
  private afterVideoUploaded = () => {
    if (this.videoUpload?.isResolved !== true)
      return;
    const results = this.videoUpload.value.Results;
    if (results.Id) {
      // single image uploaded
      const tmp = this.videoUpload.value.Results.Id;
      const id = toInt(tmp);
      if (id === null)
        return;
      this.videoUrl = uploadedFiles.videoUrl(id);
      this.videoUpload = null;
      this.videoFile = null;
    }
    if (results.Error !== null && results.Error !== undefined) {
      toastrHelper.error(results.Error);
    }
  };

  dispose = () => {
    this.disposers.dispose();
  };

}
